import { useState } from 'react';
import type { Punishment } from '../types';

interface CancelPunishmentModalProps {
  punishment: Punishment | null;
  onClose: () => void;
  onConfirm: (punishmentId: string, reason: string) => void;
  isLoading?: boolean;
}

export default function CancelPunishmentModal({
  punishment,
  onClose,
  onConfirm,
  isLoading = false,
}: CancelPunishmentModalProps) {
  const [reason, setReason] = useState('');

  if (!punishment) return null;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!reason.trim()) {
      alert('취소 사유를 입력해주세요');
      return;
    }
    onConfirm(punishment._id, reason);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
        <h2 className="text-xl font-bold mb-4">제재 취소</h2>

        <div className="mb-4 p-3 bg-gray-50 rounded">
          <p className="text-sm text-gray-600">제재 유형</p>
          <p className="font-medium">{punishment.punishmentType}</p>
          <p className="text-sm text-gray-600 mt-2">원래 사유</p>
          <p className="text-sm">{punishment.reason}</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              취소 사유
            </label>
            <textarea
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              rows={3}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="제재를 취소하는 이유를 입력하세요"
            />
          </div>

          <div className="flex justify-end space-x-3">
            <button
              type="button"
              onClick={onClose}
              disabled={isLoading}
              className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50"
            >
              닫기
            </button>
            <button
              type="submit"
              disabled={isLoading}
              className="px-4 py-2 bg-gradient-to-r from-[#FF7A7A] to-[#DD8DFF] text-white rounded-lg hover:opacity-90 disabled:opacity-50"
            >
              {isLoading ? '취소 중...' : '제재 취소'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
